<h2 mat-dialog-title>{{ isEdit ? 'Edit Vehicle' : 'New Vehicle' }}</h2>

<mat-dialog-content [formGroup]="form" class="dialog-body">
  <div class="grid">
    <mat-form-field appearance="fill">
      <mat-label>Plate Number</mat-label>
      <input matInput formControlName="plateNumber" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Model</mat-label>
      <input matInput formControlName="model" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Type</mat-label>
      <input matInput formControlName="type" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Capacity</mat-label>
      <input matInput formControlName="capacity" />
    </mat-form-field>

    <mat-slide-toggle *ngIf="isEdit" formControlName="isActive">Active</mat-slide-toggle>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()" [disabled]="loading">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="loading">
    {{ isEdit ? 'Update' : 'Save' }}
  </button>
</mat-dialog-actions>
